import React, { useEffect, useState } from 'react';
import { Box, Button, FormControl, FormGroup, FormHelperText, MenuItem, TextField, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Modal from '../../components/Modal';
import SuccessTickMark from '../../icons/SuccessTickMark';
import { FormControlLabelStyled, FormLabelStyled, IOSSwitch } from '../../style/GlobalStyles';
import { COMPANY_LIST_DETAILS } from '../../contants';
import { post } from '../../api';
import { LoadingButton } from '@mui/lab';
import { KeyboardArrowDown } from '@mui/icons-material';

function NewTaskAddButton({ updateChecklists, hasPersonalProducts }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [category, setCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const [taskName, setTaskName] = useState('');
    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState('');
    const [originalCheckList, setOriginalCheckList] = useState(COMPANY_LIST_DETAILS(!hasPersonalProducts));
    const [checkList, setCheckList] = useState(COMPANY_LIST_DETAILS(!hasPersonalProducts));
    const [showResponseError, setShowResponseError] = useState('');

    const DESCRIPTION_LENGTH = 255;
    const theme = useTheme();

    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    const handleModalOnSuccess = () => {
        handleSubmit();
    };
    const handleModalOpen = () => {
        setCategory('');
        setTaskName('');
        setDescription('');
        setCheckList(originalCheckList);
        setIsModalOpen(true);
        setLoading(false);
        setShowResponseError('');
    };

    useEffect(() => {
        post('custom/getSolutionCategoriesWithoutSolutions').then((result) => {
            if (result.isSuccess) {
                result.data.push({ id: 'other', name: 'Other' });
                setCategories(result.data);
            }
        });
    }, []);

    const handleSubmit = () => {
        let checklist = { name: taskName, shortDescription: description, solutionCategoryId: category === 'other' ? undefined : category };
        let accountIds = checkList.filter((item) => item.checked).map((item) => item.id);
        setLoading(true);
        post('custom/createNewTask', { task: checklist, accountIds }).then((result) => {
            if (result.isSuccess) {
                setIsModalOpen(false);
                setIsSuccessModalOpen(true);
                updateChecklists(result.data);
            } else {
                // setShowResponseError(typeof result.errorMessage==='string'?result.errorMessage:"data value too large")
                setShowResponseError(`Someting went wrong. please try again.`);
            }
            setLoading(false);
        });
    };

    const handleChange = (event) => {
        setCategory(event.target.value);
    };

    const handleChecklist = (currentCheckItem, checkedValue) => {
        const newList = checkList.map((cItem) => {
            if (cItem.name === currentCheckItem.name) {
                const newItem = {
                    ...cItem,
                    checked: checkedValue,
                };
                return newItem;
            }
            return cItem;
        });

        setCheckList(newList);
    };

    return (
        <>
            <Button onClick={handleModalOpen} variant="contained" color="primary" startIcon={<AddIcon />}>
                New task
            </Button>
            {isModalOpen && (
                <Modal
                    modalOpen={isModalOpen}
                    title="Add New Task"
                    hideActions={false}
                    handleModalClose={handleModalClose}
                    handleModalOnSuccess={handleModalOnSuccess}
                    submitBtnProps={{
                        disabled: !taskName || !category || !description || checkList.filter((item) => item.checked).length === 0,
                    }}
                    SubmitBtnUI={
                        <LoadingButton
                            loading={loading}
                            disabled={!taskName || !category || !description || checkList.filter((item) => item.checked).length === 0}
                            type="button"
                            variant="contained"
                            onClick={handleSubmit}
                        >
                            Save task
                        </LoadingButton>
                    }
                >
                    <Box
                        component="form"
                        display={'flex'}
                        flexDirection={'column'}
                        onSubmit={undefined}
                        noValidate
                        sx={{
                            gap: {
                                sm: '1.25rem',
                                xs: '0.75rem',
                            },
                        }}
                    >
                        <Box
                            display={'flex'}
                            sx={{
                                flexDirection: {
                                    xs: 'column',
                                    sm: 'row',
                                },
                                gap: {
                                    sm: '1.25rem',
                                    xs: '0.75rem',
                                },
                            }}
                        >
                            <FormControl fullWidth>
                                <FormLabelStyled htmlFor="taskName">Task Name</FormLabelStyled>
                                <TextField
                                    id="taskName"
                                    type="text"
                                    name="taskName"
                                    placeholder="Enter Task Name here..."
                                    required
                                    fullWidth
                                    variant="outlined"
                                    InputProps={
                                        {
                                            // color: 'secondary',
                                        }
                                    }
                                    inputProps={{ 'aria-label': 'Enter First Name' }}
                                    value={taskName}
                                    onChange={(e) => setTaskName(e.target.value)}
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <FormLabelStyled htmlFor="category">Category</FormLabelStyled>
                                <TextField
                                    select
                                    id="category"
                                    type="select"
                                    variant="outlined"
                                    // color="secondary"
                                    placeholder="Select Category"
                                    inputProps={{ 'aria-label': 'Category' }}
                                    value={category}
                                    SelectProps={{
                                        displayEmpty: true,
                                        sx: {
                                            '& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input em': {
                                                opacity: 0.42,
                                            },
                                            '& .MuiSvgIcon-root': {
                                                color: theme.palette.text.secondary,
                                            },
                                        },

                                        IconComponent: KeyboardArrowDown,
                                    }}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={''} disabled sx={{ opacity: 0.5 }}>
                                        <em>Select Category</em>
                                    </MenuItem>
                                    {categories.map((cItem, index) => (
                                        <MenuItem key={index} value={cItem.id}>
                                            {cItem.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </Box>

                        <FormControl fullWidth>
                            <FormLabelStyled htmlFor="description">Description</FormLabelStyled>
                            <TextField
                                id="description"
                                type="text"
                                multiline
                                maxRows={3}
                                minRows={3}
                                name="description"
                                placeholder="Enter task description here..."
                                required
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    // color: 'secondary',
                                    sx: {
                                        padding: 0,
                                    },
                                }}
                                inputProps={{
                                    'aria-label': 'Enter First Name',
                                    maxLength: DESCRIPTION_LENGTH, // Limit input to 20 characters
                                }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                helperText={description.length > 0 && `Keep it short! You've used ${description.length} of ${DESCRIPTION_LENGTH} characters.`} // Show character count
                            />
                        </FormControl>

                        <FormGroup
                            sx={{
                                gap: '0.5rem',
                                marginTop: {
                                    xs: '6px',
                                    sm: 'unset',
                                },
                            }}
                        >
                            <FormLabelStyled color="secondary" htmlFor="select-company">
                                Select Company
                            </FormLabelStyled>
                            {[...checkList]
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((cItem, index) => (
                                    <FormControlLabelStyled
                                        key={index}
                                        tabIndex={0}
                                        checked={cItem.checked}
                                        onChange={(e) => {
                                            handleChecklist(cItem, e.target.checked);
                                        }}
                                        control={<IOSSwitch name={cItem.name} />}
                                        label={cItem.name}
                                        labelPlacement="start"
                                    />
                                ))}
                        </FormGroup>

                        {showResponseError && (
                            <FormHelperText error sx={{ margin: '0px 0 0 4px' }}>
                                {showResponseError}
                            </FormHelperText>
                        )}
                    </Box>
                </Modal>
            )}
            {isSuccessModalOpen && (
                <Modal
                    modalOpen={isSuccessModalOpen}
                    handleModalClose={() => setIsSuccessModalOpen(false)}
                    title={''}
                    hideActions
                    sx={{
                        '& .MuiDialogContent-root': {
                            padding: '3rem 2rem 2rem 2rem',
                        },
                    }}
                >
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} gap={'1rem'}>
                        <SuccessTickMark></SuccessTickMark>
                        <Typography
                            marginTop={theme.typography.generic.xxSmall}
                            component={'p'}
                            color={'text.primary'}
                            textAlign={'center'}
                            fontSize={'customFontSize.xxxLarge'}
                            fontWeight={'fontWeightSemiBold'}
                            sx={{
                                fontSize: {
                                    xs: 'customFontSize.large',
                                    sm: 'customFontSize.xxxLarge',
                                },
                            }}
                        >
                            Task added successfully!
                        </Typography>
                        <Typography
                            component={'p'}
                            color={'text.tertiary'}
                            textAlign={'center'}
                            fontSize={'customFontSize.large'}
                            fontWeight={'fontWeightRegular'}
                            lineHeight={'140%'}
                            sx={{
                                fontSize: {
                                    xs: 'customFontSize.small',
                                    sm: 'customFontSize.large',
                                },
                            }}
                        >
                            You've added '{taskName}' to your Business checklist. Stay organized and on track!"
                        </Typography>
                        <Button variant="contained" color="primary" onClick={() => setIsSuccessModalOpen(false)}>
                            Go to Checklist
                        </Button>
                    </Box>
                </Modal>
            )}
        </>
    );
}

export default NewTaskAddButton;
